// extracted by mini-css-extract-plugin
export default {"purchasedItemOverlay":"PurchaseCard_purchasedItemOverlay__pWTpT"};